import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { Fade, AutoPlay } from "@egjs/flicking-plugins";
import { Plugin } from "@egjs/flicking";
import { ApiRestService } from '../services/api-rest.service';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
config: any;
homeAboutUs: any;
homeWork: any;
homeRequirements: any;
homeCommissions: any;
homeAboutUsExtras: any;
homeBenefit: any;
workProfitable: any;
makeMoney: any;
plugins: Plugin[] = [new Fade(), new AutoPlay()];
urlGeoApi:string;
loadGeoApi=true;
country:string;
partner:string;

 constructor(
      private appComponent: AppComponent,
      private apiRestService: ApiRestService,
    ) { 
      this.partner = this.appComponent.config.partner;
      this.config = this.appComponent.config;
      
      
    }

  ngOnInit(): void {
    this.country = this.appComponent.country;
    console.log(this.country);
    this.homeAboutUs = this.appComponent.config.homeAboutUs[this.country];
    this.homeWork = this.appComponent.config.homeWork[this.country];
    this.homeRequirements = this.appComponent.config.homeRequirements[this.country]; 
    if(this.appComponent.config.homeCommissions != undefined && this.appComponent.config.homeCommissions[this.country] != undefined){
      this.homeCommissions = this.appComponent.config.homeCommissions[this.country][0]; 
    }
    if(this.appComponent.config.homeAboutUsExtras != undefined && this.appComponent.config.homeAboutUsExtras[this.country] != undefined){
      this.homeAboutUsExtras = this.appComponent.config.homeAboutUsExtras[this.country];
    }
    if(this.appComponent.config.homeBenefit != undefined && this.appComponent.config.homeBenefit[this.country] != undefined){
      this.homeBenefit = this.appComponent.config.homeBenefit[this.country]; 
    }
    if(this.appComponent.config.workProfitable != undefined && this.appComponent.config.workProfitable[this.country] != undefined){
      this.workProfitable = this.appComponent.config.workProfitable[this.country];
    }
    if(this.appComponent.config.makeMoney != undefined && this.appComponent.config.makeMoney[this.country] != undefined){
      this.makeMoney = this.appComponent.config.makeMoney[this.country];
    }
         
  }

  getURL() {
    return this.appComponent.config.urlApi.url;
  }

}
